import type {
  CampaignChannelKind,
  ContactAgent,
  NoticeProgramRecord,
  PortfolioConnectionPublic,
} from '@workspace/types';

export const SETUP_EVENT_CHANNELS: CampaignChannelKind[] = ['WHATSAPP', 'SMS', 'EMAIL'];

export function parseCampaignChannelKind(raw: string | null | undefined): CampaignChannelKind | null {
  if (raw === 'WHATSAPP' || raw === 'SMS' || raw === 'EMAIL') {
    return raw;
  }
  return null;
}

export function boundProgramChannel(
  programs: NoticeProgramRecord[],
  programId: string | undefined,
): CampaignChannelKind {
  const found = programs.find(item => item.id === programId);
  return found?.channelKind ?? 'WHATSAPP';
}

export function avisoProgramsForChannel(
  programs: NoticeProgramRecord[],
  channelKind: CampaignChannelKind,
): NoticeProgramRecord[] {
  return programs.filter(item => item.purpose === 'AVISO' && item.channelKind === channelKind);
}

export function pickSetupEventConnections(
  connections: PortfolioConnectionPublic[],
  agents: Array<Pick<ContactAgent, 'sourceConnectionId'>>,
): PortfolioConnectionPublic[] {
  const setup = connections.filter(item => item.pluginKind === 'SETUP_MSSQL');
  const boundIds = new Set(
    agents.map(agent => agent.sourceConnectionId).filter((id): id is string => Boolean(id)),
  );
  const bound = setup.filter(item => boundIds.has(item.id));
  return uniqueSetupConnections(bound.length > 0 ? bound : setup);
}

function uniqueSetupConnections(connections: PortfolioConnectionPublic[]): PortfolioConnectionPublic[] {
  const ranked = [...connections].sort((left, right) => {
    const leftAt = left.lastSyncAt ?? left.updatedAt;
    const rightAt = right.lastSyncAt ?? right.updatedAt;
    return rightAt.localeCompare(leftAt);
  });
  const seen = new Set<string>();
  const unique: PortfolioConnectionPublic[] = [];
  for (const connection of ranked) {
    const key = setupEndpointKey(connection);
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    unique.push(connection);
  }
  return unique;
}

function setupEndpointKey(connection: PortfolioConnectionPublic): string {
  const empresa = connection.options && typeof connection.options.idempresa !== 'undefined'
    ? String(connection.options.idempresa)
    : '';
  return `${connection.host ?? ''}|${connection.port ?? ''}|${connection.database ?? ''}|${empresa}`;
}
